import { useState, useRef, useEffect } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineDown, AiOutlineRight } from "react-icons/ai";
import { Header_Menu_Items } from "../../constant/HeaderData";
import { Link } from "react-router-dom";

const HeaderMobileView = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const menuRef = useRef(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const toggleSubmenu = (submenuLabel) => {
    setActiveSubmenu(activeSubmenu === submenuLabel ? null : submenuLabel);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setActiveSubmenu(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative pr-3 lg:hidden" ref={menuRef}>
      <button
        type="button"
        onClick={toggleMenu}
        className="rounded-full p-2 pr-3 text-white transition hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        aria-expanded={menuOpen}
      >
        <GiHamburgerMenu size={30} />
      </button>

      {menuOpen && (
        <div className="absolute top-14 z-20 max-h-[calc(100vh-8rem)] w-80 overflow-y-auto overscroll-contain rounded-lg bg-[var(--website-primary-color)] text-white shadow-lg">
          <ul className="space-y-2 p-4">
            {Header_Menu_Items.map((item, index) => (
              <li key={index} className="relative">
                {item.subMenu ? (
                  <button
                    className="w-full rounded-lg text-left text-white hover:text-[var(--website-secondary-color)] px-4 py-2 hover:bg-white/5 flex justify-between items-center transition-colors"
                    onClick={() => toggleSubmenu(item.title)}
                  >
                    {item.title}
                    <span>
                      {activeSubmenu === item.title ? (
                        <AiOutlineDown />
                      ) : (
                        <AiOutlineRight />
                      )}
                    </span>
                  </button>
                ) : (
                  <Link
                    to={item.pageId}
                    className="w-full rounded-lg text-left text-white hover:text-[var(--website-secondary-color)] px-4 py-2 hover:bg-white/5 flex justify-between items-center transition-colors"
                    onClick={closeMenu}
                  >
                    {item.title}
                  </Link>
                )}

                {item.subMenu && (
                  <ul
                    className={`ml-4 mt-2 space-y-1 ${
                      activeSubmenu === item.title ? "block" : "hidden"
                    }`}
                  >
                    {item.subMenu.map((subitem, subindex) => {
                      const routePrefix =
                        item.pageId === "/services"
                          ? "/services"
                          : item.pageId === "/company"
                            ? "/company"
                            : "/details";
                      return (
                        <li key={subindex}>
                          <Link
                            to={`${routePrefix}/${subitem.pageId}`}
                            className="flex w-full items-center gap-3 rounded-lg px-4 py-2 text-left text-white hover:text-[var(--website-secondary-color)] hover:bg-white/5 transition"
                            onClick={closeMenu}
                          >
                            <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-white/10">
                              <img
                                src={
                                  subitem.logoURL
                                    ? require(`../../assets/HeaderIcons/${subitem.logoURL}`)
                                    : require(`../../assets/HeaderIcons/consultation.png`)
                                }
                                alt=""
                                loading="lazy"
                                className="h-5 w-5 object-contain"
                              />
                            </div>
                            <span>{subitem.title}</span>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default HeaderMobileView;
